import { render, staticRenderFns } from "./BackerCenterUpdateFeedCard.vue?vue&type=template&id=20da5e94"
import script from "./BackerCenterUpdateFeedCard.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports